import { playVideo } from '../helpers/play-video';

export class TabGroup {
    private container: JQuery;
    private btns: JQuery;
    private content: JQuery;
    private activeTab = '';


    /**
     * Creates a new instance of TabGroup
     * 
     * @param container The containing element.
     */
    constructor(container: HTMLElement) {
        this.container = $(container);
        this.btns      = this.container.find('.js-tab-group__btn');
        this.content   = this.container.find('.js-tab-group__content');

        this.addListeners();
    }


    /**
     * Bind the event listeners for this component
     *
     * @private
     * @memberof TabGroup
     */
    private addListeners() {
        
        // When clicking the button, change the active tab
        this.btns.each(({}, btn) => {
            $(btn).on('click', () => {
                const target = $(btn).data('for');
                this.changeTab(target);
            });
        });
    }


    /**
     * Change the currently active tab
     * 
     * @param targetTab The ID of the new tab
     */
    private changeTab(tabID: string): void {
        if(this.activeTab === tabID) return;

        this.activeTab = tabID;
        this.changeActiveContent(tabID);
        this.changeActiveButton(tabID);
    }


    /**
     * Changes the active button.
     * 
     * @param tabID The ID of the new button.
     */
    private changeActiveButton(tabID: string) {
        this.btns.each(({}, btn) => {
            const $btn = $(btn);
            const id   = $btn.data('for');

            if(tabID === id) {
                $btn.addClass('c-tab-group__btn--is-active');
            } else {
                $btn.removeClass('c-tab-group__btn--is-active');
            }
        });
    }


    /**
     * Changes the active tab.
     * 
     * @param tabID The ID of the new tab.
     */
    private changeActiveContent(tabID: string) {
        this.content.each(({}, content) => {
            const $content = $(content);
            const id       = $content.data('id');

            if(tabID === id) {
                this.openContent($content);
            } else {
                this.closeContent($content);
            }
        });
    }


    /**
     * Opens the content block.
     * 
     * @param content The content to open
     */
    private openContent(content: JQuery) {
        const sizer = content.find('.js-tab-group__inner');
        if(sizer) {
            const animationDuration = parseFloat(content.css('transition-duration')) * 1000;
            const height            = sizer.outerHeight() as number;

            content.height(height);
            setTimeout(() => {
                content.height('auto');
            }, animationDuration);

            // Play any videos
            const videos = content.find('video');
            if(videos.length) {
                videos.each(({}, video) => {
                    playVideo(video as HTMLVideoElement);
                });
            }
        }
    }


    /**
     * Closes the content block.
     * 
     * @param content The content to open
     */
    private closeContent(content: JQuery) {  
        const sizer = content.find('.js-tab-group__inner');
        if(sizer) {
            const height = sizer.outerHeight() as number;

            content.height(height);
            setTimeout(() => {
                content.height(0);
            }, 10);

            // Play any videos
            const videos = content.find('video');
            if(videos.length) {
                videos.each(({}, video) => {
                    (video as HTMLVideoElement).pause();
                });
            }
        }
    }
}
